import { PropertyPurposeType, PropertyType } from "@/enums/property.enum";

export const ListingProperty: Record<
  PropertyPurposeType,
  Array<PropertyType>
> = {
  [PropertyPurposeType.RESIDENTIAL]: [
    PropertyType.VILLA,
    PropertyType.APARTMENT,
    PropertyType.TOWNHOUSE,
  ],

  [PropertyPurposeType.COMMERCIAL]: [
    PropertyType.FULL_FLOOR,
    PropertyType.LABOR_CAMP,
    PropertyType.LAND,
    PropertyType.OFFICE,
    PropertyType.RETAIL,
    PropertyType.SHOP,
    PropertyType.SHOWROOM,
    PropertyType.STAFF_ACCOMMODATION,
    PropertyType.WAREHOUSE,
    PropertyType.WHOLE_BUILDING,
  ],
};
